import React from 'react';
import PayingAccountDF from '../components/SimulatorsComponents/DefualtSimulators/PayingAccountDF';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_D01_PayBillsPayingAccount = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <PayingAccountDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    withArrow
    isBlueBorder
    isPayBillService
    accountInfo={globJSON.configurations.services[getSubCategoryId(globJSON.screens[selectedScreen])].select_bill}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_D01_PayBillsPayingAccount;
